import Backup from './Backup.vue'
import Reminders from './Reminders.vue'
import Settings from './Settings.vue'
import Sms from './Sms.vue'
import Mail from './Mail.vue'
import SecurityClients from './SecurityClients.vue'
import SecurityPasskeys from './SecurityPasskeys.vue'
import SecurityPasswords from './SecurityPasswords.vue'
import DataMerge from './DataMerge.vue'
import Unpaid from './Unpaid.vue'
import Stats from './Stats.vue'

const routes = [{
  path: '/system/settings',
  component: Settings,
  name: 'system/settings',
  meta: { roles: ['root'] }
}, {
  path: '/system/backup',
  component: Backup,
  name: 'system/backup',
  meta: { roles: ['root'] }
}, {
  path: '/system/reminders',
  component: Reminders,
  name: 'system/reminders',
  meta: { roles: ['root'] }
}, {
  path: '/system/sms',
  component: Sms,
  name: 'system/sms',
  meta: { roles: ['root'] }
}, {
  path: '/system/mail',
  component: Mail,
  name: 'system/mail',
  meta: { roles: ['root'] }
}, {
  path: '/system/security/clients',
  component: SecurityClients,
  name: 'system/security/clients',
  meta: { roles: ['root'] }
}, {
  // Pääsuvõtmed: the switches for staff and for the customer portal.
  path: '/system/security/passkeys',
  component: SecurityPasskeys,
  name: 'system/security/passkeys',
  meta: { roles: ['root'] }
}, {
  // Lekkinud paroolid: the switch and the staff whose password is in the leaks.
  path: '/system/security/passwords',
  component: SecurityPasswords,
  name: 'system/security/passwords',
  meta: { roles: ['root'] }
}, {
  // Andmete korrastamine: one page for both, the kind from the route.
  path: '/system/data/cities',
  component: DataMerge,
  name: 'system/data/cities',
  props: { kind: 'city' },
  meta: { roles: ['root'] }
}, {
  path: '/system/data/countries',
  component: DataMerge,
  name: 'system/data/countries',
  props: { kind: 'country' },
  meta: { roles: ['root'] }
}, {
  // Andmete korrastamine: old unpaid töökäsud closed in batches.
  path: '/system/data/unpaid',
  component: Unpaid,
  name: 'system/data/unpaid',
  meta: { roles: ['root'] }
}, {
  // Töökäsud and hours by technician, type and kind of day.
  path: '/system/stats',
  component: Stats,
  name: 'system/stats',
  meta: { roles: ['root'] }
}, {
  // Where Turvalisus was before it became a group (Turvalisus -> Kliendid).
  path: '/system/security',
  redirect: { name: 'system/security/clients' }
}]

export default routes
